<div class="p-grid">
    <div class="p-col-12">
        <app-filter *ngIf="selectedWindow" [filterByInput]="cols" [filterByInputValue]="filterByInputValue" [selectedFilterGroup]="selectedFilterGroup"
            [customDateFilters]="filterDataByTime" [customSeletedDateFilter]="selectedDateFilter" [changeDateEnable]="changeDateEnable"
            (onRemoveFilter)="onRemoveFilter(selectedWindow, $event)" (onClosePanel)="onClosePanel(selectedWindow)"
            (onApplyFilter)="onApplyFilter(selectedWindow, $event)" (onChangeRange)="onChangeRange(selectedWindow, $event)">
        </app-filter>
    </div>

    <div class="p-col-12">
        <div class="card">
            <div class="main-content">
                <div *ngIf=" selectedWindow=='questionareDetail'" id="divLeadsReport">
                    <table id="excel-table" width="100%">
                        <tr>
                            <td>
                                <h5>{{reportName}}</h5>
                            </td>
                            <td style="text-align: center;">
                                <h4>{{OrganizationName}}</h4>
                            </td>
                            <td style="text-align: right;">
                                <h5>{{ dateFrom | date: 'MM/dd/yyyy'}} - {{ dateTo | date:'MM/dd/yyyy'}} </h5>
                            </td>
                        </tr>
                    </table>

                    <p-table [columns]="cols" [value]="results" [loading]="loading" [scrollable]="true"
                        [style]="{width:'100%'}" [rows]="showRows" [paginator]="true" selectionMode="single"
                        [showCurrentPageReport]="true" [rowsPerPageOptions]="[15,30,50,100]"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                        [ngStyle]="{'display':IsShowReportTemplate=== true ? 'block' : 'none' }"
                        [(first)]="firstPage">

                        <ng-template pTemplate="colgroup" let-columns>
                            <colgroup>
                                <ng-container *ngFor="let col of columns">
                                    <col style="width:auto">
                                </ng-container>
                            </colgroup>
                        </ng-template>
                        <ng-template pTemplate="header" let-columns>
                            <tr>
                                <th *ngFor="let col of columns">

                                    {{col.header}}
                                </th>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-rowData let-columns="columns">
                            <tr>
                                <td *ngFor="let col of columns">
                                    <div *ngIf="rowData['repName']==''; else nonboldContent">
                                        <b> {{rowData[col.field]}} </b>
                                    </div>

                                    <ng-template #nonboldContent>
                                        <div>

                                            <div
                                                *ngIf="col.field=='imageURL' && rowData['imageURL'] !=''; else nonboldContent1">
                                                <a [attr.href]="rowData[col.field]" [target]="'_blank'">
                                                    Attachment
                                                </a>
                                            </div>

                                            <ng-template #nonboldContent1>
                                                <div
                                                    *ngIf="col.header=='Start Date Time' || col.header=='End Date Time'; else nonboldContentque">
                                                    {{rowData[col.field] | localDate }}
                                                </div>

                                                <ng-template #nonboldContentque>
                                                    {{rowData[col.field]}}

                                                </ng-template>
                                            </ng-template>
                                        </div>
                                    </ng-template>

                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="18">{{noContactFindOrLoadingText}}</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
                <div *ngIf="selectedWindow == 'qChannel'">
                    <ng-container *ngIf="!questionnaireChartData">
                        <p class="p-text-center p-py-3">{{ loadingQuestionnaireText }}</p>
                    </ng-container>
                    <app-q-by-channel [questionnaireData]="questionnaireChartData" [dateFilterLabel]="dateFilterLabel"></app-q-by-channel>
                </div>
            </div>
        </div>
    </div>
</div>
